<template>
    <v-container>
        <v-row>
            <v-col cols="12" class="text-center">
                <h1 class="display-1 font-weight-bold mb-6">Aviso de Privacidad</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="8" offset-md="2">
                <v-card class="pa-6">
                    <h2 class="title font-weight-bold mb-4">1. Introducción</h2>
                    <p>
                        En Tech Solutions, nos comprometemos a proteger la privacidad de nuestros usuarios.
                        Este aviso de privacidad explica cómo recopilamos, usamos y protegemos su información personal.
                    </p>

                    <h2 class="title font-weight-bold mb-4">2. Información que Recopilamos</h2>
                    <p>
                        Recopilamos información personal como nombre, dirección de correo electrónico y número de
                        teléfono
                        cuando usted nos la proporciona voluntariamente.
                    </p>

                    <h2 class="title font-weight-bold mb-4">3. Uso de la Información</h2>
                    <p>
                        Utilizamos su información para proporcionarle nuestros servicios, mejorar su experiencia y
                        comunicarnos con usted.
                    </p>

                    <h2 class="title font-weight-bold mb-4">4. Protección de Datos</h2>
                    <p>
                        Implementamos medidas de seguridad para proteger su información contra el acceso no autorizado o
                        la divulgación.
                    </p>

                    <h2 class="title font-weight-bold mb-4">5. Derechos del Usuario</h2>
                    <p>
                        Usted tiene derecho a acceder, corregir o eliminar su información personal en cualquier momento.
                    </p>

                    <h2 class="title font-weight-bold mb-4">6. Contacto</h2>
                    <p>
                        Si tiene preguntas sobre este aviso de privacidad, contáctenos en <a
                            href="mailto:privacidad@techsolutions.com">privacidad@techsolutions.com</a>.
                    </p>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
};
</script>

<style scoped>
/* Estilos personalizados si es necesario */
</style>